import React, { useState } from "react";
import axios from "axios";
import AdminLayout from "./adminLayout";

const EmailConfigForm = () => {
  const [emails, setEmails] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${API_URL}/api/send-email`,
        { emails, subject, body },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = response.data; // ✅ Use response from axios

      setMessage(`✅ ${result}`);
      setEmails("");
      setSubject("");
      setBody("");
    } catch (error) {
      console.error("Email send error:", error);
      setMessage("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="p-4 sm:p-6 bg-white rounded-lg shadow-lg max-w-3xl w-full mx-auto mt-20">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Send Email to Customers</h2>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          <input
            type="text"
            placeholder="Enter email addresses (comma-separated)"
            value={emails}
            onChange={(e) => setEmails(e.target.value)}
            className="w-full p-3 border rounded border-gray-300"
            required
          />

          <input
            type="text"
            placeholder="Email subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="w-full p-3 border rounded border-gray-300"
            required
          />

          <textarea
            placeholder="Email body"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            className="w-full p-3 border rounded border-gray-300 h-32"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className={`${
              loading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
            } text-white font-bold py-2 px-6 rounded w-full sm:w-fit`}
          >
            {loading ? "Sending..." : "Send Email"}
          </button>

          {message && <p className="text-sm text-gray-700 mt-2">{message}</p>}
        </form>
      </div>
    </AdminLayout>
  );
};

export default EmailConfigForm;
